import React from 'react';

import HistoryDrawer from '../historyDrawer/HistoryDrawer';
import { getPayloadStatusDesc } from '../../utils/getStatusDesc';

// The payload status log. The drawer itself now lives in `historyDrawer/` as a
// shared primitive, because the ticket banner mounts the same thing from
// Display — which never loads payloadNew.css. This keeps the payload's own
// vocabulary and copy in one place, unchanged.
//
// The strings here are still hardcoded English, as they have always been.
// Translating them is a one-line change now that they are props, and it stays
// on PayloadNew's pending list rather than riding along with the ticket work.
const StatusDrawer = ({ open, onClose, history }) => (
	<HistoryDrawer
		open={open}
		onClose={onClose}
		history={history}
		statusDesc={getPayloadStatusDesc}
		eyebrow='Payload timeline'
		title='Status history'
	/>
);

export default StatusDrawer;
